import { render, staticRenderFns } from "./piratedriver.modal.vue?vue&type=template&id=6464750a"
import script from "./piratedriver.modal.vue?vue&type=script&lang=js"
export * from "./piratedriver.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports